import { useEffect, useState } from "react";
import { ApiCall } from "../../../helper/axios";

let citiesCache = null;
let citiesPromise = null;

const fetchAllCities = () => {
    if (citiesCache) return Promise.resolve(citiesCache);
    if (!citiesPromise) {
        citiesPromise = ApiCall("POST", "/excursions/all-cities", {}, {})
            .then((res) => {
                const list = res?.data?.data?.cities;
                if (Array.isArray(list)) {
                    citiesCache = list;
                    return citiesCache;
                }
                citiesPromise = null;
                return [];
            })
            .catch(() => {
                citiesPromise = null;
                return [];
            });
    }
    return citiesPromise;
};

export const cityNameToSlug = (name) =>
    String(name ?? "")
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/(^-|-$)/g, "");

export const useAllCities = () => {
    const [cities, setCities] = useState(citiesCache ?? []);
    const [loading, setLoading] = useState(!citiesCache);

    useEffect(() => {
        let mounted = true;
        fetchAllCities().then((list) => {
            if (mounted) {
                setCities(list);
                setLoading(false);
            }
        });
        return () => {
            mounted = false;
        };
    }, []);

    return { cities, loading };
};
